import { DetailPageParams } from './types';
import { removeQueryParam } from '../../utils/url';
import { URL_PARAMS_TO_REMOVE } from './const';

export const formatDetailPageParams = (params): DetailPageParams => {
	const formatted: Partial<DetailPageParams> = {};

	for (const key in params) {
		if (params.hasOwnProperty(key)) {
			formatted[key.toLowerCase()] = Number(params[key]);
		}
	}

	return formatted as DetailPageParams;
};

export const cleanUpUrl = (url: string): string => {
	return URL_PARAMS_TO_REMOVE.reduce((memo, param) => {
		return removeQueryParam(memo, param);
	}, url);
};
